import React, { useState, useEffect } from 'react';
import { Col, Label, Row } from 'reactstrap';
import DollarInput from '../../../common/DollarInput';
import DecimalInput from '../../../common/DecimalInput';
import { H3 } from '../../../../AbstractElements';
import { useGetRequestQuery } from '../../../../Hooks/useGetRequestQuery';
import { getAssetsInvPropertyByIdService, getAssetsPropertyByIdService, insertOrUpdateAssetsInvPropertyService } from '../../../../Services/PublicPageServices';
import { useParams } from 'react-router-dom';
import { useMutationRequestQuery } from '../../../../Hooks/useMutationRequestQuery';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';  // Add this import

export function EditInvestmentProperty() {
    const location = useLocation();
    const navigate = useNavigate();  // Add this hook
    const { homeAddress } = location.state || {}; // Retrieve the homeAddress
    const { estimatedValue } = location.state || {}; // Retrieve the homeAddress

    // Now you can use homeAddress in your component
    // console.log('Home Address:', homeAddress);
    const [formData, setFormData] = useState<any[]>([]); // Initialize as an array
    const [propertyData, setPropertyData] = useState<any>({});
    const { propertyId } = useParams();
    const categories = [
        "Advertising for Tenants",
        "Body Corporate",
        "Capital Works improvements",
        "Cleansing",
        "Council Rates",
        "Depreciation - Building",
        "Depreciation - Fixtures & Fittings",
        "Gardening & Lawn Mowing",
        "Insurance - Building",
        "Land Tax",
        "Loan Interest",
        "Property Management",
        "Repairs",
        "Stationary, Telephone & Postage",
        "Travel Expenses",
        "Water Rates"
    ];

    const calculateGrossYieldAnnual = () => {
        const rentalIncomeObj = formData.find(item => item.columnName === "Rental Income");
        const rentalIncome = parseFloat((rentalIncomeObj?.annualValue || '0').replace(/,/g, ''));
        const estimatedValues = parseFloat((propertyData.estimatedValue || '0').replace(/,/g, ''));
        
        if (estimatedValues > 0) {
            const grossYield = ((rentalIncome / estimatedValues) * 100).toFixed(2);
            return grossYield;
        }
        return '0.00';
    };

    // console.log('checkkkkkkkkkk', propertyData);

    const handleValueChange = (columnName: string, annualValue: string, monthlyValue: string) => {
        setFormData((prevData: any[]) => {
            const updatedData = [...prevData];
            const index = updatedData.findIndex(item => item.columnName === columnName);
            if (index !== -1) {
                updatedData[index] = {
                    propertyID: propertyId,
                    columnName,
                    annualValue,
                    monthlyValue
                };
            } else {
                updatedData.push({
                    propertyID: propertyId,
                    columnName,
                    annualValue,
                    monthlyValue
                });
            }

            // Calculate Gross Yield when Rental Income changes
            if (columnName === "Rental Income") {
                const grossYield = calculateGrossYieldAnnual();
                const grossYieldIndex = updatedData.findIndex(item => item.columnName === "Gross Yield");
                if (grossYieldIndex !== -1) {
                    updatedData[grossYieldIndex] = {
                        propertyID: propertyId,
                        columnName: "Gross Yield",
                        annualValue: grossYield,
                        monthlyValue: ''
                    };
                } else {
                    updatedData.push({
                        propertyID: propertyId,
                        columnName: "Gross Yield",
                        annualValue: grossYield,
                        monthlyValue: ''
                    });
                }
            }

            // Calculate Total Operating Expenses when any category changes
            const totalMonthlyExpenses = categories.reduce((total, categoryName) => {
                const monthlyValue = parseFloat(updatedData.find(item => item.columnName === categoryName)?.monthlyValue.replace(/,/g, '') || '0');
                return total + monthlyValue;
            }, 0).toString();

            const totalAnnualExpenses = (parseFloat(totalMonthlyExpenses) * 12).toString();
            const totalExpensesIndex = updatedData.findIndex(item => item.columnName === "Total Operating Expenses");
            if (totalExpensesIndex !== -1) {
                updatedData[totalExpensesIndex] = {
                    propertyID: propertyId,
                    columnName: "Total Operating Expenses",
                    annualValue: totalAnnualExpenses,
                    monthlyValue: totalMonthlyExpenses
                };
            } else {
                updatedData.push({
                    propertyID: propertyId,
                    columnName: "Total Operating Expenses",
                    annualValue: totalAnnualExpenses,
                    monthlyValue: totalMonthlyExpenses
                });
            }

            // Calculate Net Profit or Loss
            const rentalIncomeMonthly = parseFloat(updatedData.find(item => item.columnName === "Rental Income")?.monthlyValue.replace(/,/g, '') || '0');
            const netProfitOrLossMonthly = (rentalIncomeMonthly - parseFloat(totalMonthlyExpenses)).toString();
            const netProfitOrLossAnnual = (parseFloat(netProfitOrLossMonthly) * 12).toString();
            const netProfitOrLossIndex = updatedData.findIndex(item => item.columnName === "Net Profit or Loss");
            if (netProfitOrLossIndex !== -1) {
                updatedData[netProfitOrLossIndex] = {
                    propertyID: propertyId,
                    columnName: "Net Profit or Loss",
                    annualValue: netProfitOrLossAnnual,
                    monthlyValue: netProfitOrLossMonthly
                };
            } else {
                updatedData.push({
                    propertyID: propertyId,
                    columnName: "Net Profit or Loss",
                    annualValue: netProfitOrLossAnnual,
                    monthlyValue: netProfitOrLossMonthly
                });
            }

            // Calculate Tax Refund if Loss
            const netProfitOrLossValue = parseFloat(updatedData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue.replace(/,/g, '') || '0');
            const taxRateValue = parseFloat(updatedData.find(item => item.columnName === "Your Tax Rate")?.monthlyValue.replace(/,/g, '') || '0');
            const taxRefundIfLossMonthly = (netProfitOrLossValue * taxRateValue).toString();
            const taxRefundIfLossAnnual = (parseFloat(taxRefundIfLossMonthly) * 12).toString();
            const taxRefundIfLossIndex = updatedData.findIndex(item => item.columnName === "Tax Refund if Loss");
            if (taxRefundIfLossIndex !== -1) {
                updatedData[taxRefundIfLossIndex] = {
                    propertyID: propertyId,
                    columnName: "Tax Refund if Loss",
                    annualValue: taxRefundIfLossAnnual,
                    monthlyValue: taxRefundIfLossMonthly
                };
            } else {
                updatedData.push({
                    propertyID: propertyId,
                    columnName: "Tax Refund if Loss",
                    annualValue: taxRefundIfLossAnnual,
                    monthlyValue: taxRefundIfLossMonthly
                });
            }

            // Calculate Net Cashflow
            const netCashflowMonthly = (netProfitOrLossValue * taxRateValue).toString();
            const netCashflowAnnual = (parseFloat(netCashflowMonthly) * 12).toString();
            const netCashflowIndex = updatedData.findIndex(item => item.columnName === "Net Cashflow");
            if (netCashflowIndex !== -1) {
                updatedData[netCashflowIndex] = {
                    propertyID: propertyId,
                    columnName: "Net Cashflow",
                    annualValue: netCashflowAnnual,
                    monthlyValue: netCashflowMonthly
                };
            } else {
                updatedData.push({
                    propertyID: propertyId,
                    columnName: "Net Cashflow",
                    annualValue: netCashflowAnnual,
                    monthlyValue: netCashflowMonthly
                });
            }

            return updatedData;
        });
    };

    const {
        data: assetsPropertyFormData,
        isLoading: assetsPropertyFormDataLoading,
        isError: assetsPropertyFormDataIsError,
    } = useGetRequestQuery(
        ["getAssetsPropertyByIdService", propertyId],
        () => getAssetsPropertyByIdService(propertyId),
        {
            enabled: !!propertyId,
        }
    );

    useEffect(() => {
        if (assetsPropertyFormData?.data && !assetsPropertyFormDataIsError && !assetsPropertyFormDataLoading) {
            setPropertyData(assetsPropertyFormData?.data || []);
            
            // Calculate loan interest based on mortgage and interest rate
            if (assetsPropertyFormData?.data?.currentMortgage && assetsPropertyFormData?.data?.interestRate) {
                const mortgage = parseFloat(assetsPropertyFormData.data.currentMortgage.replace(/,/g, '')) || 0;
                const rate = parseFloat(assetsPropertyFormData.data.interestRate) || 0;
                const annualInterest = mortgage * (rate / 100);
                const monthlyInterest = annualInterest / 12;
                
                // Update the loan interest in formData
                setFormData(prevData => {
                    const updatedData = [...prevData];
                    const index = updatedData.findIndex(item => item.columnName === "Loan Interest");
                    if (index !== -1) {
                        updatedData[index] = {
                            propertyID: propertyId,
                            columnName: "Loan Interest",
                            annualValue: annualInterest.toFixed(0),
                            monthlyValue: monthlyInterest.toFixed(0)
                        };
                    } else {
                        updatedData.push({
                            propertyID: propertyId,
                            columnName: "Loan Interest",
                            annualValue: annualInterest.toFixed(0),
                            monthlyValue: monthlyInterest.toFixed(0)
                        });
                    }
                    return updatedData;
                });
            }
        }
    }, [assetsPropertyFormData, assetsPropertyFormDataIsError, assetsPropertyFormDataLoading]);

    const {
        data: assetInvPropertyFormData,
        isLoading: assetsInvropertyFormDataLoading,
        isError: assetsInvropertyFormDataIsError,
    } = useGetRequestQuery(
        ["getAssetsInvPropertyByIdService", propertyId],
        () => getAssetsInvPropertyByIdService(propertyId),
        {
            enabled: !!propertyId,
        }
    );

    useEffect(() => {
        if (assetInvPropertyFormData?.data && !assetsInvropertyFormDataIsError && !assetsInvropertyFormDataLoading) {
            setFormData(assetInvPropertyFormData?.data || []);
        }
    }, [assetInvPropertyFormData, assetsInvropertyFormDataIsError, assetsInvropertyFormDataLoading]);

    const { mutate: updateClientInvAssets, isPending: isUpdateClientInvAssetsPending } = useMutationRequestQuery(
        'insertOrUpdateAssetsInvPropertyService',
        insertOrUpdateAssetsInvPropertyService,
        {
            onSuccess: () => {
                console.log("Investment property information saved or updated successfully.");
                // toast.success("Investment property information saved or updated successfully.");
            },
            onError: (error: any) => {
                toast.error("Failed to submit investment property information");
                console.error(error);
            },
        }
    );

    const handleSubmit = () => {
        updateClientInvAssets(formData)
        console.log('Formatted Data for Submission:', formData);
    };
    // Add calculation function here
    const calculateTotalExpenses = () => {
        return categories.reduce((total, categoryName) => {
            const annualValue = parseFloat(formData.find(item => item.columnName === categoryName)?.annualValue) || 0;
            return total + annualValue;
        }, 0).toFixed(0);
    };

    console.log(formData)
    return (
        <div className='container-fluid'>
            <div className="table-responsive h-100 py-4">
                <section className='bg-white' onBlur={handleSubmit}>
                    <div className="scrollable-table-container">
                        <table className="scrollable-table" style={{ marginLeft: '0%', marginTop: '3%' }}>
                            <div className="d-flex align-items-center">
                                <Col xs={12} className='d-flex align-items-center justify-content-between'>
                                    <H3 className="heading-color f-w-900 text-left my-2">
                                        Profit & Loss: {homeAddress || 'Address not available'}  , ${propertyData.estimatedValue}
                                    </H3>
                                    <div>
                                        <button 
                                            onClick={() => navigate(-1)}
                                            style={{
                                                backgroundColor: '#6c757d',
                                                color: 'white',
                                                padding: '8px 16px',
                                                border: 'none',
                                                borderRadius: '4px',
                                                marginRight: '8px'
                                            }}
                                        >
                                            Back
                                        </button>
                                        {/* <button 
                                            style={{
                                                backgroundColor: '#0d6efd',
                                                color: 'white',
                                                padding: '8px 16px',
                                                border: 'none',
                                                borderRadius: '4px',
                                            }}
                                        >
                                            Save
                                        </button> */}
                                    </div>
                                </Col>
                            </div>
                            <Row className='mt-4'>
                                <div className='d-flex'>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Item</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Monthly</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Annual</Label>
                                    </Col>
                                
                                </div>
                                <div className="container-fluid">
                                
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3">Rental Income</Label>
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                             <DollarInput
                                                label=""
                                                name="Rental Income-monthly"
                                                value={formData.find(item => item.columnName === "Rental Income")?.monthlyValue || ''}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    const annualValue = (monthlyValue * 12).toString();
                                                    handleValueChange("Rental Income", annualValue, value);
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                            />
                                            
                                      
                                        </Col>

                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Rental Income-annual"
                                                value={formData.find(item => item.columnName === "Rental Income")?.annualValue || ''}
                                                setValue={(name, value) => handleValueChange("Rental Income", value, formData.find(item => item.columnName === "Rental Income")?.monthlyValue || '')}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                        {/* Add Rental Income and Gross Yield separately */}
                                        <div className='p-3 rounded mb-3 d-flex align-items-center' 
                                         style={{ 
                                             backgroundColor: 'rgb(49, 181, 59)',
                                             width: '30%',
                                             marginLeft: '30%'
                                         }}>
                                        <span className="text-white f-w-900" style={{ fontSize: '1.2rem', color: '#2e7d32' }}>
                                            DEPRECIATION<br/>
                                            Depreciation can reduce taxable income based upon Division 40 & 43 ATO guidelines.<br/>
                                            Please obtain advice from your Accountant.
                                        </span>
                                    </div>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Gross Yield</Label> {/* Bold label */}
                                        </Col>
                                     
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            {/* <DecimalInput
                                                label=""
                                                name="Gross Yield-monthly"
                                                value={calculateGrossYieldAnnual()}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            /> */}
                                        </Col>

                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            {/* <DecimalInput
                                                label=""
                                                name="Gross Yield-annual"
                                                value={formData.find(item => item.columnName === "Gross Yield")?.annualValue || calculateGrossYieldAnnual()}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    const annualValue = (monthlyValue * 12).toString();
                                                    handleValueChange("Gross Yield", annualValue, value);
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            /> */}


                                              <DecimalInput
                                                label=""
                                                name="Gross Yield-monthly"
                                                value={calculateGrossYieldAnnual()}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div>
                                    <Col className="responsive-col-expense" xs={12}>
                                        <Label className="mb-3 f-w-900">Less Expenses</Label>
                                    </Col>
                                    {categories.map((categoryName, index) => (
                                        <div key={index} className='d-flex item-center'>
                                            <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                                <Label className="mb-3">{categoryName}</Label>
                                            </Col>

                                            <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                                <DollarInput
                                                    label=""
                                                    name={`${categoryName}-monthly`}
                                                    value={formData.find(item => item.columnName === categoryName)?.monthlyValue || ''}
                                                    setValue={(name, value) => {
                                                        const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                        const annualValue = (monthlyValue * 12).toString();
                                                        handleValueChange(categoryName, annualValue, value);
                                                    }}
                                                    placeholder=""
                                                    design="flex"
                                                    limit={8}
                                                />
                                            </Col>


                                            <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                                <DollarInput
                                                    label=""
                                                    name={`${categoryName}-annual`}
                                                    value={formData.find(item => item.columnName === categoryName)?.annualValue || ''}
                                                    setValue={() => {}}  // Empty function since it's read-only
                                                    placeholder=""
                                                    design="flex"
                                                    limit={8}
                                                    disabled    
                                                />
                                            </Col>
                                        
                                        </div>
                                    ))}
                                    {/* Additional fields at the bottom */}
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Total Operating Expenses</Label> {/* Bold label */}
                                        </Col>
                                   
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Total Operating Expenses-monthly"
                                                value={formData.find(item => item.columnName === "Total Operating Expenses")?.monthlyValue || 
                                                    categories.reduce((total, categoryName) => {
                                                        const monthlyValue = parseFloat(formData.find(item => item.columnName === categoryName)?.monthlyValue || '0');
                                                        return total + monthlyValue;
                                                    }, 0).toString()}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    const annualValue = (monthlyValue * 12).toString();
                                                    handleValueChange("Total Operating Expenses", annualValue, value);
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled

                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Total Operating Expenses-annual"
                                                value={formData.find(item => item.columnName === "Total Operating Expenses")?.annualValue || ''}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Net Profit or Loss</Label> {/* Bold label */}
                                        </Col>
                                      
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Net Profit or Loss-monthly"
                                                value={formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue || ''}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    const annualValue = (monthlyValue * 12).toString();
                                                    handleValueChange("Net Profit or Loss", annualValue, value);
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled

                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Net Profit or Loss-annual"
                                                value={formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue || ''}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Net Yield</Label> {/* Bold label */}
                                        </Col>
                                       
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            {/* <DecimalInput
                                                label=""
                                                name="Net Yield-monthly"
                                                value={(
                                                    (parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue || '0') / 
                                                    (parseFloat((propertyData.estimatedValue || '0').replace(/,/g, '')) || 1) * 100)
                                                ).toFixed(0)}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            /> */}
                                        </Col>
                                        
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            {/* <DecimalInput
                                                label=""
                                                name="Net Yield-annual"
                                                value={(
                                                    (parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue || '0') / 
                                                    (parseFloat((propertyData.estimatedValue || '0').replace(/,/g, '')) || 1) * 100)
                                                ).toFixed(0)}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            /> */}


<DecimalInput
                                                label=""
                                                name="Net Yield-monthly"
                                                value={(
                                                    (parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue || '0') / 
                                                    (parseFloat((propertyData.estimatedValue || '0').replace(/,/g, '')) || 1) * 100)
                                                ).toFixed(2)}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Your Tax Rate</Label> {/* Bold label */}
                                        </Col>
                                      
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DecimalInput
                                                label=""
                                                name="Your Tax Rate-monthly"
                                                value={formData.find(item => item.columnName === "Your Tax Rate")?.monthlyValue || ''}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    handleValueChange("Your Tax Rate", value, value); // Set both monthly and annual to same value
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DecimalInput
                                                label=""
                                                name="Your Tax Rate-annual"
                                                value={formData.find(item => item.columnName === "Your Tax Rate")?.monthlyValue || ''} // Use monthlyValue for both
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Tax Payable if Profit</Label>
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Tax Payable if Profit-monthly"
                                                value={
                                                    parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue?.replace(/,/g, '') || '0') > 0
                                                        ? (
                                                            parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue?.replace(/,/g, '') || '0') *
                                                            (parseFloat(formData.find(item => item.columnName === "Your Tax Rate")?.monthlyValue?.replace(/,/g, '') || '0')/ 100)
                                                        ).toFixed(0) 
                                                        : ''
                                                }
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                                style={{ color: 'green' }}
                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Tax Payable if Profit-annual"
                                                value={
                                                    parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue?.replace(/,/g, '') || '0') > 0
                                                        ? (
                                                            parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue?.replace(/,/g, '') || '0') *
                                                            (parseFloat(formData.find(item => item.columnName === "Your Tax Rate")?.annualValue?.replace(/,/g, '') || '0') / 100)
                                                        ).toFixed(0) 
                                                        : ''
                                                }
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                                style={{ color: 'green' }}
                                            />
                                        </Col>
                                    </div>
                                    <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Tax Refund if Loss</Label>
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Tax Refund if Loss-monthly"
                                                value={
                                                    parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue?.replace(/,/g, '') || '0') < 0
                                                        ? (
                                                            parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.monthlyValue?.replace(/,/g, '') || '0') *
                                                            (parseFloat(formData.find(item => item.columnName === "Your Tax Rate")?.monthlyValue?.replace(/,/g, '') || '0')/ 100)
                                                        ).toFixed(0) 
                                                        : ''
                                                }
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                                style={{ color: 'red' }}
                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Tax Refund if Loss-annual"
                                                value={
                                                    parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue?.replace(/,/g, '') || '0') < 0
                                                        ? (
                                                            parseFloat(formData.find(item => item.columnName === "Net Profit or Loss")?.annualValue?.replace(/,/g, '') || '0') *
                                                            (parseFloat(formData.find(item => item.columnName === "Your Tax Rate")?.annualValue?.replace(/,/g, '') || '0')/ 100 )
                                                        ).toFixed(0) 
                                                        : ''
                                                }
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                                style={{ color: 'red' }}
                                            />
                                        </Col>
                                    </div>
                                    {/* <div className='d-flex item-center'>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                            <Label className="mb-3 f-w-900">Tax Payable if Profit                                 </Label> 
                                        </Col>
                                      
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Net Cashflow-monthly"
                                                value={formData.find(item => item.columnName === "Net Cashflow")?.monthlyValue || ''}
                                                setValue={(name, value) => {
                                                    const monthlyValue = parseFloat(value.replace(/,/g, '')) || 0;
                                                    const annualValue = (monthlyValue * 12).toString();
                                                    handleValueChange("Net Cashflow", annualValue, value);
                                                }}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled

                                            />
                                        </Col>
                                        <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                            <DollarInput
                                                label=""
                                                name="Net Cashflow-annual"
                                                value={formData.find(item => item.columnName === "Net Cashflow")?.annualValue || ''}
                                                setValue={() => {}}
                                                placeholder=""
                                                design="flex"
                                                limit={8}
                                                disabled
                                            />
                                        </Col>
                                    </div> */}
                                </div>
                            </Row>
                        </table>
                    
                    </div>
                </section>
            </div>
        </div>
    );

}